import React from "react";

import { Checkbox } from "@shared/checkbox";

import { Accordion } from "../accordion";

import { type FB_WINDOW, FB_WINDOWS } from "./fb-metrics-selector";

interface FbAttributionWindowsSelectorProps {
  selectedFbWindows: Set<FB_WINDOW["value"]>;
  setSelectedFbWindows: (arg0: Set<FB_WINDOW["value"]>) => void;
}

export const FbAttributionWindowsSelector = ({
  selectedFbWindows,
  setSelectedFbWindows,
}: FbAttributionWindowsSelectorProps) => {
  const toggleFbWindowVisibility = (window: FB_WINDOW) => {
    const newSelectedFbWindows = new Set(selectedFbWindows);
    if (newSelectedFbWindows.has(window.value)) {
      newSelectedFbWindows.delete(window.value);
    } else {
      newSelectedFbWindows.add(window.value);
    }
    setSelectedFbWindows(newSelectedFbWindows);
  };

  return (
    <Accordion
      title="Select Facebook attribution windows"
      isExpandedByDefault
      testId="fb-attribution-windows"
    >
      <div className="text-xxs mb-4 my-2">
        <button
          className="mr-4 hover:text-primary"
          onClick={() =>
            setSelectedFbWindows(new Set(FB_WINDOWS.map(({ value }) => value)))
          }
        >
          Select All
        </button>
        <button
          className="hover:text-primary"
          onClick={() => setSelectedFbWindows(new Set([]))}
        >
          Clear All
        </button>
      </div>
      <div className="grid grid-cols-2 text-xs font-light gap-1.5">
        {FB_WINDOWS.map((window) => (
          <div
            key={window.value}
            className="flex-horizontal-center cursor-pointer mb-4"
            onClick={() => toggleFbWindowVisibility(window)}
          >
            <Checkbox
              className="mr-2"
              onChange={() => {
                // Do nothing
              }}
              value={selectedFbWindows.has(window.value)}
            />
            <span>{window.name}</span>
          </div>
        ))}
      </div>
    </Accordion>
  );
};
